import { useEffect, useState } from "react";
import { BLITZ_CI_AUTH, DEFAULT_INITIAL_ROUTE } from "./constants";
import { useNavigate } from "react-router-dom";

function useAuthenticated() {
  const navigate = useNavigate();
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(true);

  useEffect(() => {
    const accessToken = sessionStorage.getItem(BLITZ_CI_AUTH);
    if (!accessToken) {
      setIsUserAuthenticated(false);
      return;
    }

    // Check if JWT is expired
    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      if (payload.exp && Date.now() >= payload.exp * 1000) {
        setIsUserAuthenticated(false);
        return;
      }
    } catch (e) {
      setIsUserAuthenticated(false);
      return;
    }

    setIsUserAuthenticated(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionStorage.getItem(BLITZ_CI_AUTH)]);

  useEffect(() => {
    if (isUserAuthenticated && ["/login"].includes(window.location.pathname)) {
      navigate(DEFAULT_INITIAL_ROUTE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthenticated]);

  return isUserAuthenticated;
}

export default useAuthenticated;
